import { Helpers } from '../../helpers';
import { IProjectDrillingParameter } from '../../interfaces/iproject-drilling-parameter';
import { DrillDesign } from '../drill-design';
import { DrillGroup } from '../drill-group';
import { Pad } from '../pad';
import { PadSize } from '../pad-size';
import { Project } from '../project';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ProjectDrillingParametersFormationTop } from '../project-drilling-parameters-formation-top';
import { Rig } from '../rig';
import { ScenarioWell } from '../scenario-well';
import { Well } from '../well';

export class ProjectDrillingParameterBase {
  ProjectDrillingParameterId: number;
  ProjectId: number | null;
  PadId: number | null;
  RigId: number | null;
  WellId: number | null;
  TargetFormationId: number | null;
  DrillGroupId: number | null;
  ConductorDepth: number | null;
  CurveHeight: number | null;
  CurveHeightVerticalSection: number | null;
  CurveLength: number | null;
  KickOffPoint: number | null;
  KickOffPointTrueVerticalDepth: number | null;
  KickOffPointMeasuredDepth: number | null;
  IntermediateOneCasingDepthMeasuredDepth: number | null;
  IntermediateTwoCasingDepthMeasuredDepth: number | null;
  IntermediateThreeCasingDepthMeasuredDepth: number | null;
  LandingPointOverride: number | null;
  LandingPointMeasuredDepth: number | null;
  LateralLength: number | null;
  LateralLengthOverride: number | null;
  StepOut: number | null;
  StepOutOverride: number | null;
  SurfaceCasingDepthMeasuredDepth: number | null;
  SurfaceCasingDepthMeasuredDepthOverride: number | null;
  IntermediateThreeCasingDepthMeasuredDepthOverride: number | null;
  IntermediateTwoCasingDepthMeasuredDepthOverride: number | null;
  IntermediateOneCasingDepthMeasuredDepthOverride: number | null;
  IsIntermediateOilBasedMud: boolean;
  IsIntermediateOneCasingDepthMeasuredDepthOverride: boolean;
  IsIntermediateTwoCasingDepthMeasuredDepthOverride: boolean;
  IsIntermediateThreeCasingDepthMeasuredDepthOverride: boolean;
  IsLateralLengthOverride: boolean;
  IsStepOutOverride: boolean;
  IsSurfaceCasingDepthMeasuredDepthOverride: boolean;
  IsMudLogging: boolean;
  ScenarioWellId: number | null;
  DrillGroupWellId: number | null;
  PadSizeId: number | null;
  StepProductionDrillCurve: number | null;
  StepProductionDrillLateral: number | null;
  ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointTrueVerticalDepth: number | null;
  ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateCasingPointTrueVerticalDepth: number | null;
  ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointTrueVerticalDepth: number | null;
  ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointMeasuredDepth: number | null;
  ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateTwoCasingPointMeasuredDepth: number | null;
  ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointMeasuredlDepth: number | null;
  WellTotalDepthMeasuredDepth: number | null;
  StepSurfaceDrill: number | null;
  StepIntermediateDrill: number | null;
  StepIntermediateTwoDrill: number | null;
  StepProductionDrillVertical: number | null;
  IsLandingPointOverride: boolean;
  DrillDesignId: number | null;
  IsSurfaceHoleLocationPointOfPenetrationXCoordinateOverride: boolean;
  SurfaceHoleLocationPointOfPenetrationXCoordinateOverride: number | null;
  IsSurfaceHoleLocationPointOfPenetrationYCoordinateOverride: boolean;
  SurfaceHoleLocationPointOfPenetrationYCoordinateOverride: number | null;
  IsBottomHoleLocationXCoordinateOverride: boolean;
  BottomHoleLocationXCoordinateOverride: number | null;
  IsBottomHoleLocationYCoordinateOverride: boolean;
  BottomHoleLocationYCoordinateOverride: number | null;
  IsFirstTakePointXCoordinateOverride: boolean;
  FirstTakePointXCoordinateOverride: number | null;
  IsFirstTakePointYCoordinateOverride: boolean;
  FirstTakePointYCoordinateOverride: number | null;
  WellsOnPad: number | null;
  WellsInDrillGroup: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectCompletionsParameters_ProjectDrillingParameter?: Array<ProjectCompletionsParameter> | null;
  ProjectDrillingParametersFormationTops_ProjectDrillingParameter?: Array<ProjectDrillingParametersFormationTop> | null;
  DrillDesign?: DrillDesign;
  DrillGroup?: DrillGroup;
  Pad?: Pad;
  PadSize?: PadSize;
  Project?: Project;
  Rig?: Rig;
  ScenarioWell?: ScenarioWell;
  Well?: Well;

  constructor(item?: IProjectDrillingParameter) {
    if (item) {

      this.ProjectDrillingParameterId = item.ProjectDrillingParameterId;
      this.ProjectId = item.ProjectId;
      this.PadId = item.PadId;
      this.RigId = item.RigId;
      this.WellId = item.WellId;
      this.TargetFormationId = item.TargetFormationId;
      this.DrillGroupId = item.DrillGroupId;
      this.ConductorDepth = item.ConductorDepth;
      this.CurveHeight = item.CurveHeight;
      this.CurveHeightVerticalSection = item.CurveHeightVerticalSection;
      this.CurveLength = item.CurveLength;
      this.KickOffPoint = item.KickOffPoint;
      this.KickOffPointTrueVerticalDepth = item.KickOffPointTrueVerticalDepth;
      this.KickOffPointMeasuredDepth = item.KickOffPointMeasuredDepth;
      this.IntermediateOneCasingDepthMeasuredDepth = item.IntermediateOneCasingDepthMeasuredDepth;
      this.IntermediateTwoCasingDepthMeasuredDepth = item.IntermediateTwoCasingDepthMeasuredDepth;
      this.IntermediateThreeCasingDepthMeasuredDepth = item.IntermediateThreeCasingDepthMeasuredDepth;
      this.LandingPointOverride = item.LandingPointOverride;
      this.LandingPointMeasuredDepth = item.LandingPointMeasuredDepth;
      this.LateralLength = item.LateralLength;
      this.LateralLengthOverride = item.LateralLengthOverride;
      this.StepOut = item.StepOut;
      this.StepOutOverride = item.StepOutOverride;
      this.SurfaceCasingDepthMeasuredDepth = item.SurfaceCasingDepthMeasuredDepth;
      this.SurfaceCasingDepthMeasuredDepthOverride = item.SurfaceCasingDepthMeasuredDepthOverride;
      this.IntermediateThreeCasingDepthMeasuredDepthOverride = item.IntermediateThreeCasingDepthMeasuredDepthOverride;
      this.IntermediateTwoCasingDepthMeasuredDepthOverride = item.IntermediateTwoCasingDepthMeasuredDepthOverride;
      this.IntermediateOneCasingDepthMeasuredDepthOverride = item.IntermediateOneCasingDepthMeasuredDepthOverride;
      this.IsIntermediateOilBasedMud = item.IsIntermediateOilBasedMud;
      this.IsIntermediateOneCasingDepthMeasuredDepthOverride = item.IsIntermediateOneCasingDepthMeasuredDepthOverride;
      this.IsIntermediateTwoCasingDepthMeasuredDepthOverride = item.IsIntermediateTwoCasingDepthMeasuredDepthOverride;
      this.IsIntermediateThreeCasingDepthMeasuredDepthOverride = item.IsIntermediateThreeCasingDepthMeasuredDepthOverride;
      this.IsLateralLengthOverride = item.IsLateralLengthOverride;
      this.IsStepOutOverride = item.IsStepOutOverride;
      this.IsSurfaceCasingDepthMeasuredDepthOverride = item.IsSurfaceCasingDepthMeasuredDepthOverride;
      this.IsMudLogging = item.IsMudLogging;
      this.ScenarioWellId = item.ScenarioWellId;
      this.DrillGroupWellId = item.DrillGroupWellId;
      this.PadSizeId = item.PadSizeId;
      this.StepProductionDrillCurve = item.StepProductionDrillCurve;
      this.StepProductionDrillLateral = item.StepProductionDrillLateral;
      this.ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointTrueVerticalDepth = item.ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointTrueVerticalDepth;
      this.ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateCasingPointTrueVerticalDepth = item.ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateCasingPointTrueVerticalDepth;
      this.ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointTrueVerticalDepth = item.ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointTrueVerticalDepth;
      this.ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointMeasuredDepth = item.ThreeStringCONVIntermediateCasingPointFourStringIntermediateTwoCasingPointMeasuredDepth;
      this.ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateTwoCasingPointMeasuredDepth = item.ThreeStringMODSAIntermediateCasingPointFourStringSAIntermediateTwoCasingPointMeasuredDepth;
      this.ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointMeasuredlDepth = item.ThreeStringMODCFIntermediateCasingPointFourStringCFIntermediateCasingPointMeasuredlDepth;
      this.WellTotalDepthMeasuredDepth = item.WellTotalDepthMeasuredDepth;
      this.StepSurfaceDrill = item.StepSurfaceDrill;
      this.StepIntermediateDrill = item.StepIntermediateDrill;
      this.StepIntermediateTwoDrill = item.StepIntermediateTwoDrill;
      this.StepProductionDrillVertical = item.StepProductionDrillVertical;
      this.IsLandingPointOverride = item.IsLandingPointOverride;
      this.DrillDesignId = item.DrillDesignId;
      this.IsSurfaceHoleLocationPointOfPenetrationXCoordinateOverride = item.IsSurfaceHoleLocationPointOfPenetrationXCoordinateOverride;
      this.SurfaceHoleLocationPointOfPenetrationXCoordinateOverride = item.SurfaceHoleLocationPointOfPenetrationXCoordinateOverride;
      this.IsSurfaceHoleLocationPointOfPenetrationYCoordinateOverride = item.IsSurfaceHoleLocationPointOfPenetrationYCoordinateOverride;
      this.SurfaceHoleLocationPointOfPenetrationYCoordinateOverride = item.SurfaceHoleLocationPointOfPenetrationYCoordinateOverride;
      this.IsBottomHoleLocationXCoordinateOverride = item.IsBottomHoleLocationXCoordinateOverride;
      this.BottomHoleLocationXCoordinateOverride = item.BottomHoleLocationXCoordinateOverride;
      this.IsBottomHoleLocationYCoordinateOverride = item.IsBottomHoleLocationYCoordinateOverride;
      this.BottomHoleLocationYCoordinateOverride = item.BottomHoleLocationYCoordinateOverride;
      this.IsFirstTakePointXCoordinateOverride = item.IsFirstTakePointXCoordinateOverride;
      this.FirstTakePointXCoordinateOverride = item.FirstTakePointXCoordinateOverride;
      this.IsFirstTakePointYCoordinateOverride = item.IsFirstTakePointYCoordinateOverride;
      this.FirstTakePointYCoordinateOverride = item.FirstTakePointYCoordinateOverride;
      this.WellsOnPad = item.WellsOnPad;
      this.WellsInDrillGroup = item.WellsInDrillGroup;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectCompletionsParameters_ProjectDrillingParameter = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_ProjectDrillingParameter);
      this.ProjectDrillingParametersFormationTops_ProjectDrillingParameter = Helpers.createClassArray(ProjectDrillingParametersFormationTop, item.ProjectDrillingParametersFormationTops_ProjectDrillingParameter);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.Pad = new Pad(item.Pad);
      this.PadSize = new PadSize(item.PadSize);
      this.Project = new Project(item.Project);
      this.Rig = new Rig(item.Rig);
      this.ScenarioWell = new ScenarioWell(item.ScenarioWell);
      this.Well = new Well(item.Well);
    }
  }
}